import { ReactNode } from "react";
import { Container, StyledTypography } from "./style";
import isMobile from "is-mobile";

interface ModalHeaderTextProps {
  text: ReactNode;
  secundaryText?: string;
}
export function ModalHeaderText({ text, secundaryText }: ModalHeaderTextProps) {
  return (
    <Container>
      <StyledTypography
        ownerState={{
          fontWeight: 600,
          color: "#404252",
          fontSize: isMobile() ? 18 : 20,
          minWidth: "fit-content",
        }}
        style={{ flex: 1 }}
      >
        {text}
      </StyledTypography>

      {secundaryText && (
        <StyledTypography
          ownerState={{
            color: "#404252",
            fontSize: 12,
            minWidth: "fit-content",
          }}
          style={{ flex: 1 }}
        >
          {secundaryText}
        </StyledTypography>
      )}
    </Container>
  );
}
